import React, { ChangeEventHandler } from "react";
import { CommentQuestion } from "anketa-core/command_question";
import { CommentInput } from "./input";
import { CommentQuestionList } from "./commentList";

export const CommentQuestionField = ({
  props,
  setValue,
}: {
  props: CommentQuestion;
  setValue: (comment: string) => void;
  value: string;
}): JSX.Element => {
  const { createTime, user: commentUser } = props.commentValues;

  if (commentUser === undefined && createTime === undefined) {
    return <CommentInput props={props} setValue={setValue} />;
  } else {
    return <CommentQuestionList props={props} />;
  }
};
